import axios from "axios";
import { Auth } from "../types/auth.types";

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL+'/api/v1';
export const login = async (username: string, password: string, organizationId?: string) => {
    return (await axios.post<Auth>(`${BACKEND_URL}/login`, {username: username, password: password,  organization_id: organizationId})).data
}

export const authAPI = {
    login
}